import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import {
    HideExtraHeader,
    HideExtraFooter,
    HidePlaceHolder,
    InvestmentOptionWrapper,
    ComponentDivide,TotalErrorMessage,
    DisplayFlexSpaceMobile
} from './styles';
import { Row, Col} from 'antd';
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import { connect } from "react-redux";
import history from "../../../../../../history/history";
import { step1Edit } from "../../actions";
import { CapsuleButtonWrapper } from "../ContributionType/styles";
import InvestmentPreference from "./Components/InvestmentPreference";
import InvestmentTable from "./Components/InvestmentTable/InvestmentTable";
import InvestmentAllocationCard from "./Components/InvestmentAllocationCard/InvestmentAllocationCard";
import { BusinessDate } from "../ReviewContributionAndSubmit/styles";
import {DisplayFlex} from "../../../../../../CommonComponents/commonStyles";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import { initiateTracking, recordError } from "../../../../../../utils/commonUtil";
import Popup from "../ContributionType/Components/Popup/Popup";
import { investmentOptionsState } from "../../selectors";
let isCancelClicked = false;
let popUpState = false;

export class InvestmentOptions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {show: false };
    }

    componentDidMount() {
        if (
          history.location.state &&
          history.location.state.advisorType === "step2Edit"
        ) {
          this.props.step1Edit({ step: 2, edit: true });
          window.scrollTo(0, 0);
        }
    }

    handleNext = enabled => {
      try {
        if (enabled) {
          window.scrollTo(0, 0);
          history.push("/contributions/make-a-contribution/review");
        }
      } catch (error) {
        recordError(error);
      }
    }

    handleBackClick = () => {
      try {
        window.scrollTo(0, 0);
        this.analyticsTracking('Back');
        history.push("/contributions/make-a-contribution");
      } catch (error) {
        recordError(error);
      }
    }

    handleCancelClick = () => {
        popUpState = true;
        isCancelClicked = true;
        this.setState({
          show: true
        });  
    }

    onCancelConfirm = () => {
        document.body.style.overflow = "";
        isCancelClicked = false;
        this.analyticsTracking('Cancel');
        this.setState({
          show: true
        });
        popUpState = false;
        this.props.step1Edit({step: 2, edit: false});
        window.scrollTo(0, 0);
        history.push("/contributions/make-a-contribution/review");  
    }

    handleUpdate = (enabled) => {
      try {
        if(enabled){
          window.scrollTo(0, 0);
          this.analyticsTracking('Update');
          history.push("/contributions/make-a-contribution/review");
        }
      } catch (error) {
        recordError(error);
      }
    }

    onExitClick = () => {
      try {
        popUpState = true;
        this.setState({
          show: true
        });
      } catch (error) {
        recordError(error);
      }
    }

    closeModal = () => {
        popUpState = false;
        this.setState({
          show: false
        });
      };

    removePopupContent = this.props.alertData && this.props.alertData.exit && this.props.alertData.exit.length ? 
    {
      heading: this.props.alertData.exit[0].field_header,
      line1: this.props.alertData.exit[0].field_description,
      line2: '',
      continue: this.props.alertData.exit[0].field_alert_button1_text,
      cancel: this.props.alertData.exit[0].field_alert_button2_text,
      type: "Info"
    } : {
        heading: "Exit Make A Contribution",
        line1: "Are you sure you want to Cancel this Contribution ?",
        line2: "Do you want to continue ?",
        continue: "continue",
        cancel: "No, take me back",
        type: "removeInfo"
      };

      cancelContent = this.props.alertData && this.props.alertData.cancel && this.props.alertData.cancel.length ? 
      {
        heading: this.props.alertData.cancel[0].field_header,
        line1: this.props.alertData.cancel[0].field_description,
        line2: '',
        continue: this.props.alertData.cancel[0].field_alert_button1_text,
        cancel: this.props.alertData.cancel[0].field_alert_button2_text,
        type: "Info"
      } : {
        heading: "Cancel changes",
        line1: "Any changes/updates made will be discarded.",
        line2: "Are you sure you want to continue?",
        continue: "continue",
        cancel: "No, take me back",
        type: "Info"
      };

    showPopUp = (index) => {
        popUpState = true;
        this.setState({show: true});
    }

    onRemoveClick = () => {
        popUpState = false;
        document.body.style.overflow = "";
        this.analyticsTracking('Exit');
        history.push("/");
      }

      analyticsTracking = (value) => {
        initiateTracking(value.toLowerCase(),'Make a Contribution', 'Step 2 Investment allocation options' ,value);
      }

    render() {
        let isNextEnabled = (this.props.totalValue == 100) ? true : false;
        let isUpdateEnabled = isNextEnabled && this.props.isEditClicked && this.props.isEdit;
        let isDummy = this.props.dummyData;
        return (
            <div>
                {popUpState === true ? (
            <Popup
              data-test='pop-comp'
              height="313px"
              width="481px"
              mwidth="88%"
              mheight="53%"
              content={ isCancelClicked ? this.cancelContent : this.removePopupContent}
              closeModal={this.closeModal}
              handleRemove={isCancelClicked ? () => this.onCancelConfirm() : () => this.onRemoveClick()}
            />
          ) : null }
          {this.props.isApiSuccess ?
                <>
                <InvestmentPreference />
                <ComponentDivide marginBottom='0' marginTop='50px' />
                <HideExtraFooter>
                    <HidePlaceHolder>
                        <Row>
                            <Col xs={0} lg={24}>
                                    <InvestmentTable investmentOption="dummy" />
                            </Col>
                        </Row>
                    </HidePlaceHolder>
                </HideExtraFooter>
                <Row><InvestmentOptionWrapper>Portfolio Solutions</InvestmentOptionWrapper></Row>
                <BusinessDate>as of {this.props.lastBusinessDate}</BusinessDate>
                <HideExtraHeader>
                    <HideExtraFooter>
                        <Row>
                            <Col xs={0} lg={24}>

                                    <InvestmentTable investmentOption="portfolioSolutions" />
                                
                            </Col>
                            <Col xs={24} lg={0}>
                                <InvestmentAllocationCard investmentOption="portfolioSolutions" />
                            </Col>
                        </Row>
                    </HideExtraFooter>
                    <ComponentDivide marginBottom='0px' marginTop="0px !important"/>
                    <Row><InvestmentOptionWrapper>Portfolio Builders</InvestmentOptionWrapper></Row>
                    <BusinessDate>as of {this.props.lastBusinessDate}</BusinessDate>
                    <HideExtraFooter>
                        <Row>
                            <Col xs={0} lg={24}>
                                
                                    <InvestmentTable investmentOption="portfolioBuilders" />
                                
                            </Col>
                            <Col xs={24} lg={0}>
                                <InvestmentAllocationCard investmentOption="portfolioBuilders" />
                            </Col>
                        </Row>
                    </HideExtraFooter>
                    <ComponentDivide marginBottom='0px' marginTop="0px !important"/>
                    <Row><InvestmentOptionWrapper>Value-driven investments</InvestmentOptionWrapper></Row>
                    <BusinessDate>as of {this.props.lastBusinessDate}</BusinessDate>
                    <Row>
                        <Col xs={0} lg={24}>    
                            
                                <InvestmentTable investmentOption="valueDriven" />
                            
                        </Col>
                        <Col xs={24} lg={0}>
                            <InvestmentAllocationCard investmentOption="valueDriven" />
                        </Col>
                    </Row>
                    <ComponentDivide marginBottom='50px' mB='24px' marginTop="0px !important"/>
                </HideExtraHeader>
                <Row>
                {this.props.totalValue < 100 ?
                    (<TotalErrorMessage data-test='error-msg'>Total must equal to 100%</TotalErrorMessage>) : ""}
                {this.props.totalValue > 100 ? 
                    <TotalErrorMessage data-test='error-msg1'>Total must equal to 100%</TotalErrorMessage> : ""
                }   
                 </Row>
        { history.location.state && history.location.state.advisorType === "step2Edit" ?
        <DisplayFlexSpaceMobile marginBottom='0'>
        <DisplayFlex>
        <GeneralButton 
              data-test='gnrl-btn'
              id="btnStep2Cancel"
              text = "Cancel"
              width = "150px"
              mobWidth = "100%"
              styling= "left"
              type = "functional"
              inverted = {true}
              onClick={ (this.props.isEditClicked && this.props.isEdit) ? this.handleCancelClick : () => this.onCancelConfirm()}
            />
        </DisplayFlex>
        <CapsuleButtonWrapper marginBottom="30px" mobMTop="15px">
        <GeneralButton 
              data-test='gnrl-btn1'
              text = "Update"
              width = "150px"
              mobWidth = "100%"
              styling= "right"
              onClick={() => this.handleUpdate(isNextEnabled)}
            />
        </CapsuleButtonWrapper>
      </DisplayFlexSpaceMobile>
      :
      <DisplayFlexSpaceMobile marginBottom='0'>
        <DisplayFlex>
        <GeneralButton 
              data-test='gnrl-btn2'
              id="btnBack"
              text = "Back"
              width = "150px"
              mobWidth = "100%"
              type = "functional"
              inverted = {true}
              styling="mr2 mb2"
              onClick={this.handleBackClick}
            />
        <GeneralButton
              data-test='gnrl-btn3'
              id="btnExit"
              text = "Exit"
              width = "150px"
              mobWidth = "100%"
              type = "functional"
              inverted = {true}
              styling="mb2"
              onClick={this.onExitClick}
        />
        </DisplayFlex>
        <GeneralButton 
              id="btnNext"
              text = "Next"
              width = "150px"
              mobWidth = "100%"
              styling= "right mb3"
              onClick={() => this.handleNext(isNextEnabled)}
            />
      </DisplayFlexSpaceMobile>
      
    }
    </>
    : <Preloader />}
            </div>
        );
    }

}

InvestmentOptions.propTypes = {
  totalValue: PropTypes.string,
  dummyData: PropTypes.bool,
  reducerData: PropTypes.object,
  alertData: PropTypes.object,
  isEditClicked: PropTypes.bool,
  lastBusinessDate: PropTypes.string,
  isEdit: PropTypes.bool,
  isApiSuccess: PropTypes.bool,
  step1Edit: PropTypes.func,
}

const mapStateToProps = state => ({
    ...investmentOptionsState(state.toJS())
  });

const mapDispatchToProps = dispatch => ({
    step1Edit: (data) => dispatch(step1Edit(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvestmentOptions));

